import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
// Selectors
import {
    makeSelectTimesheetValue
    // @ts-ignore
} from 'services/timesheet/selectors';

export interface OwnProps {
    children: React.ReactNode;
}

interface StateProps {
    isApproved?: boolean;
}

interface DispatchProps {}

type IProps = StateProps & DispatchProps & OwnProps;

export class SelectedTimesheetIsUnapprovedGate extends React.PureComponent<
    IProps
> {
    render() {
        const { children, isApproved } = this.props;
        if (isApproved) return null;
        return children;
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    isApproved: makeSelectTimesheetValue('isApproved')
});

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps)(
    SelectedTimesheetIsUnapprovedGate
);
